import UserBadgeBar from './UserBadgeBar';

/**
 * Reusable layout for top-right badge + action buttons.
 * Renders the user badge above whatever action controls are passed as children.
 */
function HeaderActionsBar({ children }) {
  return (
    <div className="dd-vstack dd-gap-3" style={{ alignItems: 'flex-end', minWidth: '260px' }}>
      <UserBadgeBar />
      <div className="dd-hstack dd-gap-3 dd-hstack-wrap" style={{ justifyContent: 'flex-end' }}>
        {children}
      </div>
    </div>
  );
}

export default HeaderActionsBar;
